import styled from "styled-components";
import { Icon } from "@ddm-design-system/icon";

export const StyledIcon = styled(Icon)``;
